import { get, post, url_domain, url_pre } from "@/plugins/api" // postJson


export function list(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/uu/order/list?page=${params.page}&per_page=${params.per_page}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function createOrder(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/uu/order/create`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function coinPrice(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/coin_price`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function amountlist(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/account/amount/history?page=${params.page}&per_page=${params.per_page}&sortby=id&source=${params.source || ''}&order=${params.order}&type=${params.type}&symbol=${params.symbol}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function withdrawUSDC(params) {
    return new Promise((resolve, reject) => {
        post(`${url_domain()}${url_pre()}/wallet/usd/withdraw`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}